import Decimal from "decimal.js";
import { BaseDbObject } from "../../models/db";
import { Customer, Trader } from "../reports";
import { Commodities } from "../commodity";

export interface TradingAccount extends BaseDbObject {
  provider_type: ProviderType;
  account_id: string;

  is_otc?: boolean;
  is_futures?: boolean;
  is_options_otc?: boolean;

  OpenOptionTrades?: TradingAccountOpenPosition[];
  OpenOptionsTradeAudits?: TradingAccountOpenPositionAudit[];
}

export interface TradingAccountOpenPosition extends BaseDbObject {
  is_manually_inserted: boolean;
  is_manually_fully_paired: boolean;
  trading_account_id: string;

  date: Date;
  option_month: string;

  net_position: string;
  long_qty: number;
  short_qty: number;

  put_or_call?: PutCallType;
  contract: string;
  commodity?: Commodities;
  bushel?: number;

  price: number;
  premium: number;

  strike_price?: Decimal;

  original_row: any;

  contract_no?: string;
  is_position_adjustment?: boolean;
  position_adjustment_id?: string;

  TradingAccount?: TradingAccount;
}

export interface TradingAccountOpenPositionAdjustmentMember extends BaseDbObject {
  adjustment_id: string;
  position_id: string;
}

export interface TradingAccountOpenPositionAdjustment extends BaseDbObject {
  deleted_at: string | null;
  valid_from: string;
  valid_to: string;
  commodity: string;
  option_month: string;
  strike_price: string | null;
  put_or_call: PutCallType | null;
  total_long_qty: string;
  total_short_qty: string;
  residual_long_qty: string;
  residual_short_qty: string;
  residual_bushel: string;
  carrier_position_id: string | null;
  created_by_user_id: string;
  deleted_by_user_id: string | null;
  Members: TradingAccountOpenPositionAdjustmentMember[];
}

export interface TradingAccountOpenPositionAudit extends BaseDbObject {
  is_manually_inserted: boolean;
  is_manually_fully_paired: boolean;

  trading_account_id: string;

  date: Date;
  option_month: string;

  net_position: string;
  long_qty: number;
  short_qty: number;

  put_or_call?: PutCallType;
  contract: string;
  commodity?: Commodities;
  bushel?: number;

  price: number;
  premium: number;

  strike_price?: Decimal;

  original_row: any;

  TradingAccount?: TradingAccount;
}

export interface TradingContract extends BaseDbObject {
  contract_type: string;
  contract_no?: string;
  contract_reference?: string;

  date: Date;

  is_manually_fully_paired: boolean;
  start_date?: Date;
  end_date?: Date;

  shipment_start_date?: Date;
  shipment_end_date?: Date;

  futures_price?: Decimal;
  otc_futures?: Decimal; // price?

  weeks?: Decimal;
  period_qty?: Decimal;
  knockout?: Decimal;

  account_no_a: string;
  account_no_b?: string;

  trade_reference?: string;
  customer_id: string;
  trader_id?: string;

  quantity: Decimal;
  commodity: string;

  option_month: string;
  step_one?: Decimal;
  step_two?: Decimal;
  step_three?: Decimal;
  double_up?: Decimal;

  option_premium: Decimal;
  contract_fee: Decimal;
  margin: Decimal;
  margin_amount: Decimal;

  adj_option_premium?: Decimal;
  adj_margin?: Decimal;
  adj_margin_amount?: Decimal;
  adj_contract_fee?: Decimal;
  last_adjusted_date?: Date;

  adj_option_premium_two?: Decimal;
  adj_margin_two?: Decimal;
  adj_margin_amount_two?: Decimal;
  adj_contract_fee_two?: Decimal;
  adjusted_date_two?: Date;

  adj_option_premium_three?: Decimal;
  adj_margin_three?: Decimal;
  adj_margin_amount_three?: Decimal;
  adj_contract_fee_three?: Decimal;
  adjusted_date_three?: Date;

  adj_option_premium_four?: Decimal;
  adj_margin_four?: Decimal;
  adj_margin_amount_four?: Decimal;
  adj_contract_fee_four?: Decimal;
  adjusted_date_four?: Date;

  adj_option_premium_five?: Decimal;
  adj_margin_five?: Decimal;
  adj_margin_amount_five?: Decimal;
  adj_contract_fee_five?: Decimal;
  adjusted_date_five?: Date;

  notes?: string;

  expected_contract_futures?: Decimal;
  actual_contract_futures?: Decimal;
  futures_margin?: Decimal;

  expected_contract_futures_step_one?: Decimal;
  expected_contract_futures_step_two?: Decimal;
  expected_contract_futures_double_up?: Decimal;
  actual_contract_futures_step_one?: Decimal;
  actual_contract_futures_step_two?: Decimal;
  actual_contract_futures_double_up?: Decimal;
  futures_margin_step_one?: Decimal;
  futures_margin_step_two?: Decimal;
  futures_margin_double_up?: Decimal;

  final_futures_expected_price?: Decimal;
  final_futures_price?: Decimal;
  final_futures_price_date?: Date;
  final_futures_price_margin?: Decimal;

  rolled_option_month?: string;
  carry?: Decimal;
  rolled_basis_month?: string;
  basis_carry?: Decimal;

  is_contract_open?: boolean;
  has_contract_adjustment: boolean;

  source_type: "form" | "tt_fill";

  Trader?: Trader;
  AccountNoA: TradingAccount;
  AccountNoB?: TradingAccount;
  Customer?: Customer;
}

export enum PutCallType {
  Put = "Put",
  Call = "Call",
}

export enum ProviderType {
  Dorman = "dorman",
  Rjo = "rjo",
}
